<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('agents')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="25"
      resource_url="/helpdesk/agent/datatables"
    ></generic-table>
  </div>

  <agent-modal ref="agent_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import AgentModal from "./agent_modal/Index.vue";

export default {
  name: "AgentsDatatable",
  components: { GenericTable, AgentModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add_agent"),
          icon: "fa fa-plus",
          class: "is-primary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            return `<div class="media">
              <div class="media-left">
                <figure class="image is-32x32">
                  <i class="fa fa-user-circle fa-2x has-text-grey-light"></i>
                </figure>
              </div>
              <div class="media-content">
                <div class="content">
                  <p class="title is-6 mb-1">${row.name || ""}</p>
                  <p class="subtitle is-7 has-text-grey">${row.email || ""}</p>
                </div>
              </div>
            </div>`;
          },
        },
        {
          title: v.$t("department"),
          name: "department",
          searchable: true,
          data: (row) => {
            return row.department || "";
          },
        },
        {
          title: v.$t("phone"),
          name: "phone",
          searchable: true,
          data: (row) => {
            return row.phone || "";
          },
        },
        {
          title: v.$t("specialties"),
          searchable: false,
          data: (row) => {
            if (row.specialties && row.specialties.length > 0) {
              return row.specialties
                .map(
                  (specialty) =>
                    `<span class="tag is-info is-light">${specialty}</span>`
                )
                .join(" ");
            }
            return "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            const statusClass = row.is_active ? "is-success" : "is-danger";
            const statusText = row.is_active
              ? v.$t("active")
              : v.$t("inactive");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.agent_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are_you_sure_delete"),
                    v,
                    () => {
                      del("/helpdesk/agent", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.agent_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
